import * as Types from "../constants/CompanyConstants";
import { all, takeEvery, put, fork, call, delay, takeLatest } from "redux-saga/effects";
import { storeCompanyMessageAction, fetchCompanySuccessAction, fetchCompaniesOk, fetchCompaniesFailed } from "../actions/CompanyActions";

import CompanyService from "services/CompanyService";


export function* fetchCompaniesEffect() {
  try {
    const { data: companies } = yield call(CompanyService.fetchAll);
    yield (put(fetchCompaniesOk(companies.result)))
  } catch ({ response }) {
    yield (
      put(
        fetchCompaniesFailed({
          status: response.status,
          message: response.data.message,
          errors: []
        })
      )
    );
  }
}

export function* storeCompanySaga() {
  yield takeEvery(Types.STORE_COMPANY, function* ({ payload }) {
    try {
      const companyService = yield call(CompanyService.setPost, payload);
      yield put(
        storeCompanyMessageAction({
          message: companyService.message,
          error: !companyService.success,
          showMessage: true,
        })
      );
      yield delay(2000);
      yield put(
        storeCompanyMessageAction({
          message: companyService.message,
          error: !companyService.success,
          showMessage: false,
        })
      );
    } catch (err) {
      console.log(err);
      yield put(
        storeCompanyMessageAction({
          message: err.message || "Storing Error",
          error: true,
        })
      );
    }
  });
}

export function* fetchCompany() {
  yield takeEvery(Types.FETCH_COMPANY, function* ({ companyId }) {
    try {
      const companyService = yield call(CompanyService.getCompany, companyId);
      yield put(
        fetchCompanySuccessAction({
          message: companyService.message,
          company: companyService.data,
        })
      );
    } catch (err) {
      console.log(err);
      yield put(
        storeCompanyMessageAction({
          message: err.message || "Storing Error",
          error: true,
        })
      );
    }
  });
}

export function* updateCompany() {
  yield takeEvery(Types.UPDATE_COMPANY, function* ({ companyId, company }) {
    try {
      const companyService = yield call(CompanyService.updateCompany, {
        companyId,
        company,
      });
      yield put(
        fetchCompanySuccessAction({
          message: companyService.message,
          company: companyService.data,
        })
      );
    } catch (err) {
      console.log(err);
      yield put(
        storeCompanyMessageAction({
          message: err.message || "Storing Error",
          error: true,
        })
      );
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(storeCompanySaga),
    fork(fetchCompany),
    fork(updateCompany),
    yield takeLatest(Types.FETCH_COMPANIES, fetchCompaniesEffect)
    // fork(signOut),
  ]);
}
